<template>
    <div>
        <!-- <div class="fxn-header-left" :class="($route.path == '/CaseInfo') || ($route.path == '/CaseDetail') ? 'fxn-header-left active' : 'fxn-header-left' " > -->
        <div class="fxn-header-left" v-if="ver_type != '7'">
            <div class="fxn-pull-left" v-if="seat_service == '0'">
                <el-button type="warning" @click="OpenService">开通坐席服务</el-button>
            </div>
            <div class="fxn-pull-left" v-else>
                <div v-show="mem_type == 2">
                    <!-- 无坐席 -->
                    <div v-if="hasSeat == 0">
                        联系本公司运营人员分配坐席
                    </div>
                    <!-- 无坐席 -->
                    
                    <!--有坐席 -->
                    <div v-else>
                        <!-- 联通 -->
                        <div v-show="callLT">
                            <div v-if="!seats && !isaicalling">
                                <el-form :model="TelForm" :rules="TelRules" ref="TelForm">
                                    <el-form-item class="fxn-header-input" label="" prop="phone">
                                        <input class="el-input__inner" type="text" v-model="TelForm.phone" autocomplete="off" maxlength="12" placeholder="请输入电话号码">
                                    </el-form-item>
                                    <div class="fxn-header-button">
                                        <el-button :type="seats ? 'info' : 'success'" style="min-width: 32px;height: 36px;" v-for="(item,index) in seatsObj" :key="index" :icon=" 'iconfont '+'iconphone'+(index+1)" @click="submitTel('TelForm',true,item.id,item.link_type)"></el-button>
                                    </div>
                                </el-form>
                            </div>
                            <div v-else-if="seats">
                                <div v-if="seatzt == 1">
                                    <i class="el-icon-service"></i>繁忙/通话中
                                    <el-button type="primary" style="min-width: 32px;height: 36px;" icon="el-icon-phone" @click="submitExitTel('TelExitForm')">挂机</el-button>
                                </div>
                                <div v-else-if="seatzt == 2"><i class="el-icon-loading"></i>繁忙</div>
                                <div v-else-if="seatzt == 3">
                                    <div class="fxn-header-button">
                                        <el-button type="primary" style="min-width: 32px;height: 36px;" icon="el-icon-phone" @click="submitExitTel('TelExitForm')">挂机</el-button>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <!-- 联通 End -->
                    </div>
                    <!-- 有坐席 End -->
                </div>
            </div>

            <div class="fxn-Header-Data" v-if="mem_type == '2'">
                <div class="item">总案件：<span>{{TopDatas.case_num}}</span></div>
                <div class="item">总金额：<span>{{TopDatas.case_money | Money}}万</span></div>
                <div class="item">回款金额：<span>{{TopDatas.repay_money | Money}}万</span></div>
                <div class="item">剩余金额：<span>{{TopDatas.surplus_money | Money}}万</span></div>
            </div>
        </div>

        <!-- 服务项 -->
        <ServiceItem></ServiceItem>   
        <!-- 服务项 End --> 
    </div>
</template>

<script>
    let ws = '';
    import ServiceItem from './ServiceItem'
    export default {
        components: {
            ServiceItem,
        },
        computed: {
            seats() {
                return this.$store.getters.isseatcalling
            },
            isaicalling() {
                return this.$store.getters.isaicalling
            }
        },
        data(){
            return{
                callLT: true,
                hasSeat: '',
                mem_type: '',
                ver_type: '',
                seat_service: '',
                seatzt: '',
                StStatus: {},           //坐席状态
                seatsObj: [],
                TopDatas: [],
                Timer: null,

                //拨打电话
                TelForm: {
                    phone: '',
                    case_id: '',
                },
                TelRules: {
                    phone: [
                        { required: true, message: '请输入呼叫号码', trigger: 'blur' },
                    ]
                },
            }
        },
        methods:{

            //拨打电话
            submitTel(formName,FromTel,seatid,link_type){
                // if (this.isaicalling || this.$store.getters.iscalling) { //预测式是否通话中 | webrtc是否通话中
                //     return false
                // }

                // if (link_type == 3 && webrtcSDK && this.$store.getters.isRegistered) { //
                //     console.log(webrtcSDK)
                //     let _this = this
                //     webrtcSDK.callPhone({
                //         phone: _this.TelForm.phone, 
                //         // encodphone: _this.$options.filters["mobile"](_this.TelForm.phone),
                //         // encoding: true
                //     })
                // } else {
                    localStorage.setItem('link_type',link_type);
                    if(!this.TelForm.phone){
                        this.$message({
                            message: '请输入手机号码',
                            type: 'error'
                        })
                        return false;
                    }
                    this.post('/osapi/Call/callOut',{
                        phone: this.TelForm.phone,
                        case_id: this.TelForm.case_id,
                        seat_id: seatid,
                        contacts_id: '',
                    })
                    .then( res=>{
                        let { msg, code, data } = res.data
                        if( code !=1 ){
                            this.OpenAside.$emit('toTel','','',false)
                            this.$message({
                                message: msg,
                                type: 'error'
                            });
                        }else{
                            //this.seats = true
                            this.$store.commit('call/SET_IS_SEAT_CALLING', true)
                            this.SeatStatus()
                            this.$refs.TelForm.resetFields();
                        }
                    })
                // }
            },

            //坐席状态
            SeatStatus(){
                let _this = this
                ws = new WebSocket(this.WebSocketUrl);
                let user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    _this.member_id = user.memberInfo.id
                }
                ws.onopen = function() {
                    ws.send('{"cmd":"seat_msgs","member_id":"'+ _this.member_id +'"}');
                };
                ws.onmessage = function(e) {
                    let seatData = JSON.parse(e.data);
                    _this.StStatus = JSON.parse(e.data);
                    _this.seatzt = seatData.seat_status
                    if (_this.seatzt == '0') {
                        // _this.seats = false
                        _this.$store.commit('call/SET_IS_SEAT_CALLING', false)
                        _this.OpenAside.$emit('toTel','','',false)
                        ws.close();
                    } else {
                        _this.$store.commit('call/SET_IS_SEAT_CALLING', true)
                    }
                };
                ws.onclose = function (event) {
                    console.log(event)
                }          
            },

            //挂机
            submitExitTel(){
                this.post('/osapi/Call/hangUp',{
                    link_type: localStorage.getItem('link_type')
                })
                .then( res=>{
                   let { msg, code, data } = res.data
                    if( code !==1 ){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        // this.seats = false;
                        this.$store.commit('call/SET_IS_SEAT_CALLING', false)
                        this.OpenAside.$emit('toTel','','',false);
                        //ws.close();
                    } 
                })
            },

            //数据统计
            topData(){
                this.get('/osapi/Cases/casesSelfStatic')
                .then(res=>{
                    let { msg, code, data } = res.data
                    if(code !== 1){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        this.TopDatas = res.data.data
                    }
                })
            },

            //打开服务窗口
            OpenService(){
                this.OpenAside.$emit('CloseService',true);
            },
        },
        created() {
            this.SeatStatus();
            // let user = JSON.parse(localStorage.getItem('user'));
            // let obj = {
            //     WebSocketUrl: this.WebSocketUrl,
            //     member_id: user.memberInfo.id
            // }
            // this.$store.dispatch('call/initSeatStatusWs', obj)
        },
        mounted(){
            this.topData();
            //获取已登录用户信息
            let user = JSON.parse(localStorage.getItem('user'));
			if (user) {
                this.hasSeat = user.memberInfo.hasSeat;
                this.mem_type = user.memberInfo.mem_type;
                this.seat_service = user.memberInfo.seat_service;
                this.ver_type = user.memberInfo.ver_type;
                this.seatsObj = user.memberInfo.seats;
            }

            if(this.seat_service != 0){
                if (this.hasSeat == 0){

                } else if (this.hasSeat > 0){
                    this.callLT = true;
                } else if (this.hasSeat == 0){
                    this.callLT = false;
                } else {
                    this.callLT = true;
                }
            }

            let that = this;
            this.OpenAside.$on('toTel',function(case_phone,case_id,type,calltype,seatid,link_type){
                if (type && !that.seats  ) {     //如果为拨号并且不在拨号状态中
                    that.TelForm.phone = case_phone;
                    that.TelForm.case_id = case_id;
                    if(calltype == 2){
                        that.callLT = false;
                        that.DYTel();
                    }else{
                        localStorage.setItem('link_type',link_type);
                        that.callLT = true;
                        that.submitTel(case_phone,case_id,seatid,link_type);
                    }
                }
            }) 
        },
        beforeDestroy() {
            this.OpenAside.$off('toTel')
        },
        watch: {
            seats(val) {
                if (!val) {
                    clearInterval(this.Timer)
                    this.Timer = null;
                } else {
                    this.OpenAside.$emit('toTel','','',true)
                }
            }
        },
    }
</script>

<style scoped>
    .active{
        left: .75rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tel.vue